// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NavItem } from '@interfaces/interfaces';
import { User } from '@interfaces/user.interfaces';
import { ContentService } from '@services/content.service';
import { NavService } from '@services/nav.service';
import { PermissionsService } from '@services/permissions.service';
import { SettingsService } from '@services/settings.service';
import { UserService } from '@services/user.service';
import { Observable, takeWhile } from 'rxjs';
import { ErrorModalComponent } from 'src/app/modals/error-modal/error-modal.component';

@Component({
    selector: 'buyer-user-header',
    templateUrl: './buyer-user-header.component.html',
    styleUrls: ['./buyer-user-header.component.scss'],
})
export class BuyerUserHeaderComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    public menu$: Observable<NavItem[]>;
    public showUserName = false;
    public user: User = null;

    constructor(
        private readonly navService: NavService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly userService: UserService,
        private readonly permissionService: PermissionsService,
        private readonly dialog: MatDialog,
        private readonly contentService: ContentService
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.menu$ = this.navService.getUserMenu(this.user);
        this.showUserName = window.innerWidth < 768 ? false : true;
    }

    ngOnInit(): void {
        this.user = this.route.snapshot.data.user;
        this.onResize();

        // subscribe to user changes from account settings
        this.userService
            .user$()
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((user) => (this.user = user));
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    private logout(): void {
        this.navService.accountType = null;
        this.userService.logOut();
        this.router.navigate(['/login']);
    }

    public navigate(item: NavItem): void {
        if (item.route.includes('login')) {
            this.logout();
        } else if (this.permissionService.hasPermission(item?.permissions?.permissionIds)) {
            this.navService.setSelectedRoute('main', item);
        } else {
            this.contentService
                .permissionsMissingError()
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((message) => {
                    this.dialog.open(ErrorModalComponent, {
                        width: '700px',
                        data: {
                            title: 'Access Restricted',
                            message,
                        },
                    });
                });
        }
    }
}
